module.exports = "/_next/static/images/PowerYourApps@2x-ab222a051e2859678dbcf93a4a1a54b7.webp";